import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../gql/api';

export const getSituationById = createAsyncThunk(
  'monitoring/getSituationById',
  async (payload) => {
    const { situationId } = payload;
    const response = await api.monitoring.getSituationById({
      situationId,
    });

    return response.data.getSituationById;
  }
);

export const getSituationsByIds = createAsyncThunk(
  'monitoring/getSituationsByIds',
  async (payload) => {
    const { situationIds } = payload;
    const response = await api.monitoring.getSituationsByIds({
      situationIds,
    });

    return response.data.getSituationsByIds;
  }
);

export const getSituationsByIdsMinimal = createAsyncThunk(
  'monitoring/getSituationsByIdsMinimal',
  async (payload) => {
    const { situationIds } = payload;
    const response = await api.monitoring.getSituationsByIdsMinimal({
      situationIds,
    });

    return response.data.getSituationsByIds;
  }
);
